function symbol(id, width, height, fill) {
  let s = {
    circle: {
      p: 'M 256, 256m -100, 0a 100,100 0 1,0 200,0a 100,100 0 1,0 -200,0',
      v: '0 0 512 512',
    },
  };
  return (
    'data:image/svg+xml;base64,' +
    window.btoa(
      '<svg xmlns="http://www.w3.org/2000/svg" height="' +
        height +
        '" viewBox="0 0 512 512" width="' +
        width +
        '" ><g><path fill="' +
        fill +
        '" d="' +
        s[id].p +
        '" /></g></svg>'
    )
  );
}

const config = {
  gridSize: 100,
  maxZoom: 14,
  styles: [
    { textColor: '#ffffff', width: 75, height: 75, url: symbol('circle', 75, 75, '#757575') },
    {
      textColor: '#ffffff',
      textSize: 14,
      width: 100,
      height: 100,
      url: symbol('circle', 100, 100, '#757575'),
    },
    {
      textColor: '#ffffff',
      textSize: 15,
      width: 120,
      height: 120,
      url: symbol('circle', 120, 120, '#757575'),
    },
  ],
};

export default config;
